export default __webpack_public_path__ + "static/media/commerce-supply-chain.6283c3a5.webp";